import { render, staticRenderFns } from "./checkVerifyToken.vue?vue&type=template&id=2442605a"
import script from "./checkVerifyToken.vue?vue&type=script&lang=js"
export * from "./checkVerifyToken.vue?vue&type=script&lang=js"
import style0 from "./checkVerifyToken.vue?vue&type=style&index=0&id=2442605a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports